__turbopack_context__.v({
  "embedCaption": "EmbedPlugin-module-scss-module__60pZMW__embedCaption",
  "embedContainer": "EmbedPlugin-module-scss-module__60pZMW__embedContainer",
  "embedWrapper": "EmbedPlugin-module-scss-module__60pZMW__embedWrapper",
});
